// extracted by mini-css-extract-plugin
module.exports = {"titleTextContainer":"blog-page-title_titleTextContainer__6clM4","title":"blog-page-title_title__x5ZDE","text":"blog-page-title_text__sF7_p"};